<template>
  <!-- 季度选择时间控件 -->
  <div class="week-picker">
    <el-date-picker
      v-model="beginTime"
      type="week"
      align="right"
      :format="formatMoment(beginTime)"
      :picker-options="pickerOptionsWeek"
      style="width: 150px;"
      @change="changeTime"
      :clearable="false"
      :placeholder="$t('weekRangePicker.kai_shi_zhou')"
    ></el-date-picker>
    <span class="bar">-</span>
    <el-date-picker
      v-model="endTime"
      type="week"
      align="right"
      :format="formatMoment(endTime)"
      :picker-options="pickerOptionsWeek"
      style="width: 150px;"
      :clearable="false"
      @change="changeTime"
      :placeholder="$t('weekRangePicker.jie_shu_zhou')"
    ></el-date-picker>
  </div>
</template>
<script>
import moment from 'moment';
/**
 * @file:  View 组件 周选择控件
 * @description: UI组件  可选择周
 * @api: value : 周value defalut 前11周 -当前周 默认值待设置
 * 代码中注释部分是组件原默认时间配置，我这里做了更改，但是原设置可以参考
 */
export default {
  name: 'WeekRangpicker',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    unbindOrgTime: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      beginTime: this.value[0],
      endTime: this.value[1],
      pickerOptionsWeek: {
        firstDayOfWeek: 1,
        disabledDate: (time) => {
          // 禁用2016年之前的日期
          const minYearLimit = moment('2015-12-28 00:00:00').valueOf();
          if (moment(time).valueOf() < minYearLimit) {
            return true;
          }
          return time > new Date();
        }
      },
      // pickerOptionsWeekEnd: {
      //   firstDayOfWeek: 1,
      //   disabledDate: time => moment(time).isAfter(this.$getLocalTime(), 'day')
      // }
    };
  },

  mounted() {
    // this.beginTime = this.value[0]).subtract(1, 'days');
    // this.endTime = this.value[1];
    this.beginTime = this.value[0];
    this.endTime = this.value[1];
  },
  watch: {
    value: function (val) {
      this.beginTime = val[0];
      this.endTime = val[1];
    },
    unbindOrgTime: {
      immediate: true,
      handler(val) {
        if (val) {
          // 已到期设备用已到期的时候
          this.pickerOptionsWeek = {
            firstDayOfWeek: 1,
            disabledDate: time => moment(time).isAfter(val, 'day')
          };
        }
      },
    },
  },
  methods: {
    formatMoment(time) {
      // 设置周的开始时间是星期一 1月1号是年开始的第一周
      moment.updateLocale('en', {
        week: {
          // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
          dow: 1, // Monday is the first day of the week.
          doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
        },
      });
      const YYYY = moment(time).endOf('week').format('YYYY');
      const w = moment(time).endOf('week').format('w');
      return this.$t('weekRangePicker.oooo', [YYYY,this.$t('weekRangePicker.di'),w,this.$t('weekRangePicker.zhou')]);
      // return moment(time).endOf('week').format(`YYYY [${'第'}] w [${'周'}]`);
    },
    changeTime() {
      // 确保 beginTime 是较小的时间，endTime 是较大的时间
      if (moment(this.beginTime).isAfter(moment(this.endTime))) {
        const temp = this.beginTime;
        this.beginTime = this.endTime;
        this.endTime = temp;
      }
      // 将时间转换为 moment 对象并传递出去
      const Timer = [moment(this.beginTime), moment(this.endTime)];
      this.$emit('input', Timer);
      this.$emit('change', Timer);
    },
  }
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.week-picker {
  font-size: 0px;
  line-height: 40px;
  .bar {
    font-size: 20px;
    line-height: 40px;
    margin: 0 3px;
    width: 20px;
    display: inline-block;
    text-align: center;
  }
  .el-date-editor{
    transform: translateX(0px) !important;
  }
  .el-input__inner {
    cursor: pointer;
    height: 40px;
    line-height: 41px;
    padding-right:30px !important;
    // margin-left: 8px;
    font-weight: bold;
    color: $--color-text-primary;
  }
  .el-input__suffix {
    // margin-right: 10px;
    color: #c0c4cc;
    width: 25px;
    // display: inline-block;
    float: right;
    right: 0;
    line-height: 32px;
    .el-input__suffix-inner {
      width: 25px;
      height: 100%;
      display: inline-block;
      vertical-align: middle;
    }
    .el-input__icon {
      width: 25px;
      height: 100%;
      display: inline;
      &:after {
        font-family: 'icon' !important;
        content: '\E7F8';
        font-size: 22px;
        color: $--color-warning;
        margin-bottom: 2px;
        display: inline;
        height: 100%;
      }
      &:before {
        display: inline;
        height: 100%;
      }
    }
  }
  .el-input__prefix {
    color: $--color-primary;
    font-size: 18px;
    margin-right: 8px;
    .icon {
      font-size: 18px;
    }
  }
}
</style>

